// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a830a7a8","455":"9bcea31d","977":"9bac61a3"}[chunkId] + ".chunk.js";
};